// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"d00c8e74","185":"c4514377","424":"8d1dc574","505":"73f123b4","678":"d7defacd","892":"95c51deb","929":"7619b992"}[chunkId] + ".chunk.js";
};